
// 评论显示组件
Vue.component("comment_list", {
  props: {
      code: "",
  },
  data() {
      return {
          comments: {
              //评论列表信息
              page: 1,
              size: 12,
              total: 0,
              list: [],
              star: 4.5,
              content: "",
          },
      };
  },
  mounted() {
      this.getCommentList();
  },
  methods: {
      // 分页size改变
      searchHandel() {
          this.comments.page = 1;
          this.getCommentList();
      },
      //获取评论列表
      getCommentList() {
          API.reqCourseEvaluationList({
              courseId: this.code,
              page: this.comments.page,
              size: this.comments.size,
          }).then((res) => {
              if (res.message === config.successMessage) {
                  this.comments.list = res.data.results;
                  this.$emit("update:length", res.data.total || 0);
                  this.comments.total = res.data.total;
              }
          });
      },
  },
  filters: {
      dateFormate(timeStamp) {
          return dateFormate(timeStamp, "y/m/d h:i:s");
      },
  },
  template: `
     <div class="comment_container">
          <div class="comment_list">
              <template v-if="comments.list.length > 0">
                  <div class="comment_item" v-for="comment in comments.list" :key="comment">
                      <el-avatar :src="comment.avatar" :size="65" @error="errorHandler" style="background:transparent;">
                        <img style="border: none;" src="/learn/static/imgs/default_avatar.png"/>
                      </el-avatar>
                      <div class="comment_info">
                          <div class="comment_username">{{comment.username}}</div>
                          <el-rate v-model="comment.star" disabled show-score allow-half
                                      text-color="#ff9900" score-template="{value}">
                          </el-rate>
                          <div class="comment_content">{{comment.content}}</div>
                          <div class="comment_time">
                              {{comment.createtime|dateFormate}}
                          </div>
                      </div>
                  </div>
              </template>
              <el-empty v-else></el-empty>
          </div>
          <!-- 分页 -->
          <el-pagination small hide-on-single-page @size-change="searchHandel" @current-change="getCommentList"
                          :current-page.sync="comments.page"
                          :page-sizes="[12, 24, 48, 60, 90, 120]" :page-size.sync="comments.size"
                          layout="total, prev, pager, next, sizes" :total="comments.total">
          </el-pagination>
      </div>
  `,
});